import { INotificationIcon } from '../INotificationIcon';
import { imgPath } from '../../../common/utilities/ImgUrl';

export const commentingNotificationIcon: INotificationIcon = {
    isProfile: true,
    systemImageUrl: null,
    secondImageUrl: imgPath('comments_xsmall.svg')
};
